var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var HeartInactive = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M11.05 17.02c1.01-.76 2.09-1.62 3.05-2.54 2.68-2.54 4.3-4.98 4.3-6.98 0-2.64-1.67-4.21-3.87-4.21a4.3 4.3 0 0 0-3.75 2.32l-.75 1.4-.7-1.4a4.04 4.04 0 0 0-3.7-2.32c-2.2 0-3.86 1.57-3.86 4.21 0 .38.05.76.16 1.2.48 1.78 1.98 3.78 4.13 5.78.96.92 2.04 1.78 3.06 2.54.32.27.64.48.96.7.27-.22.59-.43.97-.7Zm3.48-15.35C17.6 1.67 20 3.94 20 7.5c0 2.6-1.82 5.36-4.83 8.17a29.98 29.98 0 0 1-4.29 3.4c-.1.06-.21.16-.32.22-.05.05-.05.05-.1.05l-.49.33-.43-.27a2.02 2.02 0 0 0-.42-.27l-1.08-.76a36.36 36.36 0 0 1-3.21-2.65C2.47 13.5.8 11.3.2 9.18A5.62 5.62 0 0 1 0 7.56c.16-3.62 2.57-5.9 5.63-5.9 1.72 0 3.38.7 4.5 2.11a5.64 5.64 0 0 1 4.4-2.1Z" }))); });
//# sourceMappingURL=HeartInactive.js.map